import assetPath from '/app/packages/lebenslauf/articles/src/assets/arbeitsvertrag.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')